// Eléctrico Ecuador · Theme JS v1.0

document.addEventListener('DOMContentLoaded', function () {
  initBrandToggle();
  updateCartCount();
  initProductGallery();
  initQtyStepper();
  initOptionSelectors();
  initPriceFilter();
  initBrandFilter();
});

/* ─── Brand toggle (home page) ─── */
function initBrandToggle() {
  var btns = document.querySelectorAll('.ee-brand-toggle__btn');
  if (!btns.length) return;
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var brand = this.dataset.brand;
      btns.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      document.querySelectorAll('.ee-card[data-brand]').forEach(function (card) {
        card.closest('.ee-grid-item') && (card.closest('.ee-grid-item').style.display = (brand === 'all' || card.dataset.brand === brand) ? '' : 'none');
        !card.closest('.ee-grid-item') && (card.style.display = (brand === 'all' || card.dataset.brand === brand) ? '' : 'none');
      });
    });
  });
}

/* ─── Live cart count in header ─── */
function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.ee-header__cart-badge').forEach(function (b) {
        b.textContent = cart.item_count;
      });
    })
    .catch(function () {});
}

/* ─── Product page gallery ─── */
function initProductGallery() {
  var thumbs = document.querySelectorAll('.ee-product__thumb');
  var mainImg = document.getElementById('ee-main-img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (this.dataset.src) mainImg.src = this.dataset.src;
    });
  });
}

/* ─── Qty stepper ─── */
function initQtyStepper() {
  document.addEventListener('click', function (e) {
    var qty = e.target.closest('.ee-qty');
    if (!qty) return;
    var input = qty.querySelector('.ee-qty__input');
    if (!input) return;
    if (e.target.classList.contains('js-qty-dec')) {
      input.value = Math.max(1, parseInt(input.value || 1) - 1);
    }
    if (e.target.classList.contains('js-qty-inc')) {
      input.value = parseInt(input.value || 1) + 1;
    }
    input.dispatchEvent(new Event('change'));
  });
}

/* ─── Option selectors (delivery / payment) ─── */
function initOptionSelectors() {
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    group.querySelectorAll('.ee-order-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        group.querySelectorAll('.ee-order-option').forEach(function (o) { o.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  });
}

/* ─── Collection price filter (client-side) ─── */
function initPriceFilter() {
  document.querySelectorAll('.js-price-filter, .js-price-all').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.js-price-filter, .js-price-all').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var min = parseFloat(this.dataset.min) || 0;
      var max = parseFloat(this.dataset.max) || Infinity;
      var all = this.classList.contains('js-price-all');
      var visible = 0;
      document.querySelectorAll('.ee-grid-item').forEach(function (item) {
        var price = parseFloat(item.dataset.price) / 100;
        var show = all || (price >= min && price <= max);
        item.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      var counter = document.getElementById('ee-result-count');
      if (counter) counter.textContent = visible + ' resultados';
    });
  });
}

/* ─── Collection brand filter (client-side) ─── */
function initBrandFilter() {
  document.querySelectorAll('.js-brand-filter').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.js-brand-filter').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var brand = this.dataset.brand;
      var visible = 0;
      document.querySelectorAll('.ee-grid-item').forEach(function (item) {
        var show = brand === 'all' || item.dataset.brand === brand;
        item.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      var counter = document.getElementById('ee-result-count');
      if (counter) counter.textContent = visible + ' resultados';
    });
  });
}

/* ─── Add to cart (AJAX) ─── */
window.eeAddToCart = function (variantId, qty) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () { updateCartCount(); })
    .catch(function () {});
};
